import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { EditTools } from '../../EditTools';
import { useAiGenerateSingleAnswer } from './useAiGenerateSingleAnswer';
export const AiGenerateSingleAnswerButton = () => {
  const {
    generate,
    disabled
  } = useAiGenerateSingleAnswer();
  const upsellingGuard = useUpsellingGuard();
  const {
    userPlanManager
  } = useUserPlanManager();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_ANSWER_GENERATION');
  return <WithPlanBadge planType={featurePlanType} isBadgeVisible={true} data-sentry-element="WithPlanBadge" data-sentry-component="AiGenerateSingleAnswerButton" data-sentry-source-file="AiGenerateSingleAnswerButton.tsx">
      <EditTools.AiAnswerGenerationButton disabled={disabled} onClick={() => {
      void upsellingGuard(generate, {
        feature: 'AI_ANSWER_GENERATION',
        from: 'ai'
      });
    }} data-sentry-element="unknown" data-sentry-source-file="AiGenerateSingleAnswerButton.tsx" />
    </WithPlanBadge>;
};